const validateFormFieldCondition = (expectedValue, validationFieldValue) => expectedValue === validationFieldValue;

export default validateFormFieldCondition;
